<template>

    <span class="value" ref='vl' @keypress="onKeypress" @blur="blur" @focus="focus" :contentEditable="editable" :style="{color : color}">{{formattedFocused}}</span>
</template>


<style scoped lang="sass">

    ::v-deep
        br
            display: none

    [contentEditable]
        outline: 0px solid transparent

        br
            display: none


</style>
<script>
import {
    mapState
} from 'vuex';

import f from '@/application/shared/functions.js'

export default {
    name: 'value',
    props: ['value', 'mode', 'colored', 'editable'],
    
    data : function(){
        return {
            focused : false
        }
    },
    computed: mapState({
        auth: state => state.auth,
        currentStyles : state => state.currentStyles,
        valuemode : function(state){

            if(!this.mode) return null

            if (this.mode == 'auto') return state.valuemode

            return this.mode
        },

        color : function(){

            if (this.colored){

                return this.$store.getters.colorByValue(this.value)
            }

        },

        formatted : function(){

            if(this.mode == 'string' || this.mode == 'number' || this.value == 'n/a') return this.value

            if(this.mode == 'bps') return (100 * this.value).toFixed(0) + 'bps'

            return f.values.format(this.core.user.locale, this.valuemode, this.value)
            
        },

        formattedFocused : function(){
            if(this.focused && this.editable){
                if(this.mode == 'number' || this.mode == 'bps' || this.mode == 'p' || this.mode == 'd' || this.mode == 'p100'){
                    return this.clear(this.formatted)
                }
            }

            return this.formatted
        }
    }),

    methods: {

        blur : function(e){
            this.focused = false

            this.change(e)
        },

        clear : function(v = ''){
            return v.replace(/[^0-9+\-\.]+/g, '')
        },

        focus : function(){
            this.focused = true
        },
        change : function(e){
            if(!this.editable) return
            var value = e.target.innerText
            var n = false

            if(this.mode == 'string') {
            }

            if(this.mode == 'number') {
                value = Number(this.clear(value))
                n = true
            }

            if(this.mode == 'p') {
                value = Number(this.clear(value.replace("%", '')))
                n = true

            }

            if(this.mode == 'd') {
                value = Number(this.clear(value.replace("$", '')))
                n = true

            }

            if(this.mode == 'p100') {
                value = Number(this.clear(value.replace("%", ''))) / 100
                n = true

            }

            if(this.mode == 'bps') {
                value = Number(this.clear(value.replace("bps", ''))) / 100
                n = true

            }

            if (n){
                if (Number.isNaN(value)) value = 0
            }


            this.$emit('change', value)

        },

        onKeypress(e) {
            if (e.key == 'Enter') {
                e.preventDefault();
                this.$refs['vl'].blur()
            }
        }
    },
}
</script>
